import { FaFolder } from "react-icons/fa";
import { HiOutlineCubeTransparent, HiTrash } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { removeItemFromFolder } from "../../../services/folder.service";
import "../../../styles/studio/folder/studioFolderEntryCard.css";

const typeIcons = {
  folder: FaFolder,
  visualization: HiOutlineCubeTransparent,
  publication: HiOutlineCubeTransparent,
};

const StudioFolderEntryCard = ({
  entry,
  currentFolderPath = [], // ✅ ONLY source of truth
  fetchData,
  globalLoading = false,
  setGlobalLoading,
  setError,
}) => {
  const { type, item, itemId, folderEntryId } = entry;
  const uiType = type === "publication" ? "visualization" : type;
  const Icon = typeIcons[type] || HiOutlineCubeTransparent;
  const navigate = useNavigate();

  // ✅ derive current folderId from path
  const folderId = currentFolderPath[currentFolderPath.length - 1];

  // remove root from path for routing
  const pathWithoutRoot = currentFolderPath.slice(1);

  /* ---------------- NAVIGATION ---------------- */
  const handleNavigate = () => {
    if (globalLoading) return;

    if (uiType === "folder") {
      navigate(`/studio/folders/${[...pathWithoutRoot, itemId].join("/")}`);
    }
  };

  /* ---------------- REMOVE ITEM ---------------- */
  const handleRemove = async (e) => {
    e.stopPropagation();
    if (globalLoading) return;
    if (!confirm("Remove this item from folder?")) return;

    try {
      setGlobalLoading(true);
      await removeItemFromFolder(folderId, folderEntryId);
      await fetchData();
    } catch (err) {
      setError(err.message);
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <div
      className={`studio-folder-entry-card ${globalLoading ? "disabled" : ""}`}
      onClick={handleNavigate}
      style={{ pointerEvents: globalLoading ? "none" : "auto" }}
    >
      <button
        className="studio-folder-entry-card-remove"
        onClick={handleRemove}
        disabled={globalLoading}
        title={globalLoading ? "Please wait..." : "Remove from folder"}
      >
        <HiTrash />
      </button>

      <div className="studio-folder-entry-card-header">
        <div className="studio-folder-entry-card-type">{uiType}</div>
      </div>

      <div className="studio-folder-entry-card-icon">
        <Icon />
      </div>

      <div className="studio-folder-entry-card-title" title={item.title}>
        {item.title}
      </div>

      {item.description && (
        <div
          className="studio-folder-entry-card-description"
          title={item.description}
        >
          {item.description}
        </div>
      )}
    </div>
  );
};

export default StudioFolderEntryCard;
